import React, { useState } from 'react';

export default function MediaDnDList({ items, onItemsChange, onRemove }) {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (index !== draggedIndex) {
      const newList = [...items];
      const [draggedItem] = newList.splice(draggedIndex, 1);
      newList.splice(index, 0, draggedItem);
      onItemsChange(newList);
      setDraggedIndex(index);
    }
  };

  const handleDrop = () => {
    setDraggedIndex(null);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative',
        gap: '10px',
        // minHeight: '120px',
        padding: '10px 0px',
        // border: '1px dashed #ccc'
      }}
    >
      {items.map((item, index) => (
        <div
          key={item.id}
          draggable
          onDragStart={() => handleDragStart(index)}
          onDragOver={(e) => handleDragOver(e, index)}
          onDrop={handleDrop}
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '5px',
            // overflow: 'hidden',
            border: '1px solid #ddd',
            position: 'relative',
            backgroundColor: draggedIndex === index ? '#f0f0f0' : '#fff',
            cursor: 'grab'
          }}
        >
          {item.type === 'image' ? (
            <img
              src={item.url}
              alt=""
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <video
              src={item.url}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              // controls="false"
            />
          )}
          <button
            onClick={() => onRemove(item.id)}
            style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              background: 'red',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              cursor: 'pointer',
              width: '20px',
              height: '20px'
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
